import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --swiper-theme-color: #ffffff;
    --swiper-navigation-size: 25px;
    --swiper-navigation-sides-offset: 16px;

    --toastify-color-progress-light: ${(props) => props.theme.themePrimary};

    mgt-people-picker {
      --input-border: none;
      --input-border-bottom: 2px solid ${(props) =>
        props.theme.neutralQuaternaryAlt};
      --input-border-color--focus: ${(props) => props.theme.themePrimary};
      --input-border-color--hover: ${(props) => props.theme.themePrimary};
      --input-background-color: transparent;
    }

    mgt-person.mgt-person, mgt-person.mgt-dark, .ms-DetailsRow .mgt-person {
      background: transparent !important;
    }
  }
  
  :focus {
    outline: none;
  }
  
  body {
    -webkit-font-smoothing: antialiased;

    * {
      &::-webkit-scrollbar {
        width: 20px;
      }
  
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
  
      &::-webkit-scrollbar-thumb {
        background-color: #d6dee1;
        border-radius: 20px;
        border: 6px solid transparent;
        background-clip: content-box;
      }
  
      &::-webkit-scrollbar-thumb:hover {
        background-color: #a8bbbf;
      }
    }
  }
  
  body, input, text, area, button, a {
    font: 400 1rem/1.5rem 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
  }
  
  body {
    background: ${(props) => props.theme.white};
  }
  
  h1 { 
    font-weight: 600;
    margin: 0;
  }
  
  h1, h3, h4, h5, p, span {
    color: ${(props) => props.theme.black};
  } 
  
  h2 {
    color: ${(props) => props.theme.neutralTertiary};
  }
  
  .mgt-dark {
    background: ${({ theme }) => theme.neutralLighter}
  }

  .panelManage .mgt-dark {
    background: #fff;
  }
  `;
